var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvDriverRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1808_3511)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.9996,
    rx: 4,
    fill: "#F5FDF9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1808_3511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 8.92576C19.1724 5.02475 12.8269 5.02475 8.92511 8.92576C5.02496 12.8268 5.02496 19.1739 8.92511 23.0749C10.876 25.025 13.438 25.9996 16.0001 25.9996C18.5622 25.9996 21.1233 25.0249 23.0742 23.0749C26.9753 19.1739 26.9753 12.8268 23.0742 8.92576ZM20.1262 18.948C20.4522 19.2739 20.4522 19.8009 20.1262 20.1268C19.9636 20.2894 19.7502 20.3711 19.5367 20.3711C19.3233 20.3711 19.1098 20.2894 18.9473 20.1268L16.0001 17.1788L13.0537 20.126C12.8903 20.2885 12.6768 20.3703 12.4642 20.3703C12.2508 20.3703 12.0374 20.2885 11.8748 20.126C11.5488 19.8 11.5488 19.2722 11.8748 18.9471L14.8212 15.9999L11.874 13.0527C11.548 12.7267 11.548 12.199 11.874 11.8738C12.1991 11.5478 12.7269 11.5478 13.0528 11.8738L16 14.821L18.9472 11.8738C19.2732 11.5478 19.8001 11.5478 20.1261 11.8738C20.4521 12.199 20.4521 12.7267 20.1261 13.0527L17.1789 15.9999L20.1262 18.948Z",
    fill: "#32D484"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1808_3511",
    x: -10,
    y: -2,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.831373 0 0 0 0 0.517647 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1808_3511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1808_3511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1808_3511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.9996,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvDriverRating);
export default __webpack_public_path__ + "static/media/av-driver-rating.0d0c1db1149acac46f99b3a6723d9f6f.svg";
export { ForwardRef as ReactComponent };